export class OutputDto {
  fieldName: string;
  fieldValue: string;
  idPosition: Number;
  rawValue: boolean;
  fieldValueFalse: string;
  fieldValueTrue: string;
  isLock: boolean;
  isManual: boolean;

  constructor(data: Partial<OutputDto> = {}) {
    this.fieldName = data?.fieldName ?? '';
    this.fieldValue = data?.fieldValue ?? '';
    this.idPosition = data?.idPosition ?? 0;
    this.rawValue = data?.rawValue ?? false;
    this.fieldValueFalse = data?.fieldValueFalse ?? '';
    this.fieldValueTrue = data?.fieldValueTrue ?? '';
    this.isLock = data?.isLock ?? false;
    this.isManual = data?.isManual ?? false;
  }
}